import React from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { commonStyles } from "../../Services/ReactPDFService.jsx";

// ATS Prime Cover Letter Template - Blue accents with double-line divider
const styles = StyleSheet.create({
  ...commonStyles,
  page: {
    ...commonStyles.page,
    fontFamily: "Roboto",
    backgroundColor: "#ffffff",
    padding: "40 50",
  },
  headerContainer: {
   margin: 5 ,
  },
  name: {
    fontSize: 24,
    fontWeight: 700,
    color: "#2563eb",
    marginBottom: 4,
  },
  contactInfo: {
    fontSize: 10,
    color: "#333333",
    paddingTop: 10 ,
  },
  contactLink: {
    fontSize: 10,
    color: "#2563eb",
  },
  dividerTop: {
    borderBottomWidth: 2,
    borderBottomColor: "#2563eb",
    marginBottom: 2,
  },
  dividerBottom: {
    borderBottomWidth: 0.5,
    borderBottomColor: "#2563eb",
    marginBottom: 10,
  },
  bodyText: {
    fontSize: 11,
    lineHeight: 1.8,
    color: "#333333",
    textAlign: "justify",
  },
});

const ATSPrimeCoverLetter = ({ coverLetterData }) => {
  const { header, generatedContent } = coverLetterData || {};
  const { name, email, phone, location } = header || {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerContainer}>
          <Text style={styles.name}>{name || "[Name]"}</Text>
          <Text style={styles.contactInfo}>
            {[location, email, phone].filter(Boolean).join(" | ") || "[Contact Info]"}
          </Text>
        </View>
        <View style={styles.dividerTop} />
        <View style={styles.dividerBottom} />
        <Text style={styles.bodyText}>{generatedContent || "No content generated yet."}</Text>
      </Page>
    </Document>
  );
};

export default ATSPrimeCoverLetter;
